import { useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { $journalApi } from "@/entities/journal/fetch/fetch-client";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";

export const useUpdateStatusToNewEntry = ({
  sectionOneId,
  search,
}: {
  sectionOneId: string;
  search: string;
}) => {
  const queryClient = useQueryClient();

  return $journalApi.useMutation(
    "post",
    "/api/v1/journals/section-one/{sectionOneListId}/items/{itemNoVersionId}/return",
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          journalsQueries.getSection1({ sectionOneId, search }),
        );
        queryClient.invalidateQueries({
          queryKey:
            journalsQueries.getSectionOneSignersList(sectionOneId).queryKey,
        });

        notification.success({
          message: NOTIFICATION_MESSAGES.ENTRY_STATUS_UPDATED_SUCCESS, // "Статус обновлён на 'Новый'"
        });
      },
      onError: () => {
        notification.error({
          message: NOTIFICATION_MESSAGES.ENTRY_STATUS_UPDATE_ERROR, // "Не удалось обновить статус"
        });
        queryClient.invalidateQueries(
          journalsQueries.getSection1({ sectionOneId, search }),
        );
      },
      onSettled: () => {
        queryClient.invalidateQueries(
          journalsQueries.getSection1({ sectionOneId, search }),
        );
      },
    },
  );
};

